<template>
  <div class="content">
    <!-- 添加用户的表单 -->
    <el-form ref="addFormRef" :rules="rulesAddUser" :model="params" label-width="100px">
      <el-form-item prop="examname" label="试卷名称">
        <el-input v-model="params.examname"></el-input>
      </el-form-item>
      <el-form-item prop="examinfo" label="试卷介绍">
        <el-input type="textarea" :rows="10" v-model="params.examinfo"></el-input>
      </el-form-item>
      <el-form-item label="图标">
        <el-upload class="avatar-uploader" multiple name="files" action="" :http-request="fnUploadRequest" :show-file-list="false" :before-upload="beforeUpload"
          :on-success="handleAvatarSuccess" :data="{filename: 'files'}" accept=".jpg,.png">
          <img v-if="params.icon" :src="params.icon" class="avatar">
          <i v-else class="el-icon-camera avatar-uploader-icon"></i>
        </el-upload>
        <div class="input-tips">
          <span>建议使用80*80像素</span>
          <span>仅支持jpg和png的格式</span>
        </div>
      </el-form-item>
      <el-form-item label="难度">
        <el-radio-group label="难度" v-model="params.difficulty">
          <el-radio :label="1">简单</el-radio>
          <el-radio :label="2">一般</el-radio>
          <el-radio :label="3">困难</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="答案及解析">
        <el-radio-group label="答案及解析" v-model="params.answer">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="标签" class="not-must">
        <el-tag :key="tag" v-for="tag in params.tags" closable :disable-transitions="false" @close="handleClose(tag, 'subject')">
          {{tag}}
        </el-tag>
        <el-input class="input-new-tag" v-if="tagVisible" v-model.trim="tagValue" :maxlength="10" ref="saveTagInput" size="small"
          @keyup.enter.native="handleInputConfirm('subject')" @blur="handleInputConfirm('subject')">
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showTagInput('subject')">+ 标签</el-button>
      </el-form-item>
      <el-form-item prop="score" label="满分">
        <el-input v-model="params.score" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item prop="bp" label="总积分">
        <el-input v-model="params.bp" :disabled="true"></el-input> 分
      </el-form-item>
      <el-form-item prop="exp" label="总经验值">
        <el-input v-model="params.exp" :disabled="true"></el-input> 分
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('addFormRef')">确定</el-button>
        <el-button @click="addDialogClose()">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import oss from '@/utils/aliOss';
import { saveTargetProjectTaskAddActivityData, selectTargetProjectTaskActivityData } from "@/api/contest";
export default {
  computed: {
    validating() {
      return this.$parent.validateState === 'validating';
    }
  },
  props: ['paperId', 'paperData'],
  mounted() {
    this.initData()
  },
  watch: {
    //			paperId:function(){
    //				this.initData()
    //			},
  },
  data() {
    return {
      tagVisible: false,
      tagValue: '', //标签值
      paper_id: this.paperId,
      // 添加用户
      params: {
        id: '',
        examname: '',
        examinfo: '',
        icon: '',
        difficulty: 2,
        answer: 1,
        tags: [],
        score: 0,
        bp: 0,
        exp: 0,
      },
      // 验证规则
      rulesAddUser: {
        examname: [
          { required: true, message: '请输入试卷名称！', trigger: 'blur' },
          {
            validator(rule, value, callback, source, options) {
              let errors = [];
              if (value.length > 30 || value === '') {
                callback('请输入1-30位字符!');
              }
              callback(errors);
            }
          }
        ],
        examinfo: [
          { message: '试卷介绍为0-200位字符!', trigger: 'blur' },
          {
            validator(rule, value, callback, source, options) {
              let errors = [];
              if (value.length > 200) {
                callback('试卷介绍为0-200位字符!');
              }
              callback(errors);
            }
          }
        ],
      }
    }
  },
  methods: {
    //初始化数据
    initData: function () {
      if (this.paperId) {
        this.setObj(this.paperData)
      } else {
        this.restData()
      }
    },
    //填充data数据
    setObj: function (data) {
      this.params.id = data.content_id
      this.params.examname = data.paper_title
      this.params.examinfo = data.paper_introduce
      this.params.icon = data.icon
      this.params.answer = data.is_parsing
      this.params.tags = data.label
      this.params.difficulty = data.difficulty
      this.params.exp = data.experience ? data.experience : 0
      this.params.bp = data.integral ? data.integral : 0
      this.params.score = data.score ? data.score : 0
    },
    // 标签删除
    handleClose(tag, type = '') {
      if (type === 'activity') {
        this.activitySetting.tags.splice(this.activitySetting.tags.indexOf(tag), 1);
      }
      if (type === 'subject') {
        this.params.tags.splice(this.params.tags.indexOf(tag), 1);
      }
    },
    // 增加标签
    showTagInput(type = '') {
      if ((type === 'activity' && this.activitySetting.tags.length >= 5) ||
        (type === 'subject' && this.params.tags.length >= 5)) {
        this.$message('最多只能添加五个标签'); return;
      }
      this.tagVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 标签输入确认
    handleInputConfirm(type = '') {
      if (this.tagValue) {
        if (type === 'activity' && this.activitySetting.tags.indexOf(this.tagValue) === -1) {
          this.activitySetting.tags.push(this.tagValue);
        }
        if (type === 'subject' && this.params.tags.indexOf(this.tagValue) === -1) {
          this.params.tags.push(this.tagValue);
        }
      }
      this.tagVisible = false;
      this.tagValue = '';
    },
    // 关闭弹框的回调
    addDialogClose() {
      this.$refs['addFormRef'].resetFields()//关闭前清空表单
      this.$emit("close");//调用父组件的方法
    },
    handleCreate() {
      let that = this;
      let params = this.addFormRef;
      createCourse(params).then(response => {
        this.$message.success({
          message: '登录成功',
          onClose: function () {
            that.$emit("close");
          }
        })

      });
    },
    submitForm(formName) {
      let params = {
        task_id: sessionStorage.getItem('taskId'),
        paper_id: this.paperId ? this.paperId : 0,
        activity_type: 4,
        paper_title: this.params.examname,
        paper_introduce: this.params.examinfo,
        icon: this.params.icon,
        label: this.params.tags,
        difficulty: this.params.difficulty,
        is_parsing: this.params.answer,
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveTargetProjectTaskAddActivityData(params).then(response => {
            let obj = {
              paper_title: this.params.examname,
              paper_id: this.paperId ? this.paperId : Number(response.data),
              is_parsing: this.params.answer,
            }
            this.$message.success('保存成功')
            this.$root.$emit('returnexam', obj);
          })
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    restData() {
      this.params = {
        id: '',
        examname: '',
        examinfo: '',
        icon: '',
        difficulty: 2,
        answer: 1,
        tags: [],
        score: 0,
        bp: 0,
        exp: 0,
      }
    },
    // 图片上传尺寸大小检验
    beforeUpload(file) {
      let _this = this;
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      if (!isJPG && !isPNG) {
        this.$message.error('仅支持jpg和png格式');
        return false
      }
    },
    handleAvatarSuccess(res, file) {
      if (!res) return
      this.params.icon = res.res.requestUrls[0].split('?')[0];
    },
    /**
    * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
    * @param    {object}   option [上传选项]
    * @return   {null}   [没有返回]
    */
    async fnUploadRequest(option) {
      oss.ossUploadFile(option, 1)
    },
  }

};
</script>

<style scoped>
.el-dialog__header {
  background-color: #e9eaeb;
}
</style>